import requestCtxs from '@/sealFilter/requestCtxs'
//根据条件查询系统机构信息
export function loginInfo (data) {
    return requestCtxs({
        url: '/system/ttv3/manage/system/org/info/query/by/condition',
        method: 'post',
        data
    })
}

//登陆
export function login (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/user/reader/login',
        method: 'post',
        data
    })
}

export function checkCode (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/checkCode',
        method: 'post',
        data
    })
}  

//自动登录
export function readerAutoLogin (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/user/reader/auto/login',
        method: 'post',
        data
    })
}  

//根据登录传参查询机构信息
export function getLoginOrgInfo (data) {
    return requestCtxs({
        url:'/manage/ttv3/manage/system/org/info/query/bydircode',
        // url: '/auth/ttv3/security/core/org/sec/dir/bydircode',
        method: 'post',
        data
    })
}

//发送验证码
export function sendCode (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/sms/send',
        method: 'post',
        data
    })
}  

//手机号登录
export function phoneLogin (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/sms/login',
        method: 'post',
        data
    })
}  
//获取微信二维码
export function wxCode (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/wxqrcode/unique/code',
        method: 'post',
        data
    })
}  
  
//微信扫一扫登录状态
export function wxLoginStatus (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/wxqrcode/login/state',
        method: 'post',
        data
    })
}  
//微信扫一扫
export function wxSucInfo (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/wxqrcode/login/sucinfo',
        method: 'post',
        data
    })
}  

//根据orgid查询机构信息
export function orgInfoByid(data){
    return requestCtxs({
        url:'/system/ttv3/manage/system/org/info/query/byid',
        method:'post',
        data
    })
}

//统一身份验证
// export function orgInfoByid(data){
//     return requestCtxs({
//         url:'/system/ttv3/manage/system/org/info/query/byid',
//         method:'post',
//         data
//     })
// }


// WEBPACK FOOTER //
// ./src/api/login.js